/** @jsx isolateComponent */
import { Text, Button } from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';
import { useStaticAssetPath } from '@zapier/common-components';
import { Interpolation } from '@emotion/css';

const tabletMediaQuery = `@media screen and (min-width: 1000px)`;

const Styles = labelStyles(__filename, {
  root: (isCondensed: boolean) => [
    {
      height: '349px',
      display: 'grid',
      padding: '40px 0 20px 120px',
      [tabletMediaQuery]: {
        paddingLeft: '100px',
      },
    },
    isCondensed &&
      withModifier('isCondensed', {
        paddingLeft: 0,
        paddingTop: 0,
        height: '310px',
        textAlign: 'center',
        paddingBottom: '50px',
        gridGap: '10px',
      }),
  ],
  image: (promoImgUrl: string) => ({
    backgroundImage: `url("${promoImgUrl}")`,
    backgroundPosition: 'left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '147px 498px',
    position: 'absolute',
    height: '499px',
    width: '147px',
    left: '25px',
    top: '-1px',
  }),
  text: { zIndex: 1 },
});

type CompaniesIntroPromoProps = {
  /** Is this condensed from a narrow screen? */
  isCondensed: boolean;
};

const CompaniesIntroPromo = (props: CompaniesIntroPromoProps) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();
  const promoImgUrl = buildStaticAssetUrl('/images/login/companies-login.png');
  return (
    <div css={Styles.root(props.isCondensed) as Interpolation}>
      {!props.isCondensed && (
        <div css={Styles.image(promoImgUrl) as Interpolation} />
      )}
      <div css={Styles.text}>
        <Text color="grey900" tag="h1" type="header800">
          Ready to scale your business?
        </Text>
      </div>
      <div css={Styles.text}>
        <Text color="grey900" type="subtitle700">
          Easily collaborate with your team with shared Zaps and app
          connections, a centralized login, and more
        </Text>
      </div>
      <Button hasShadow={true} href="/companies" size="small">
        Try Our New Company Plan
      </Button>
    </div>
  );
};

export default CompaniesIntroPromo;
